import React, { useState, useEffect } from 'react'
import { Card, CardBody, Container, Row, Col, FormGroup, Label, Input, Button, ButtonGroup, InputGroup, InputGroupText, Tooltip } from 'reactstrap';
import ReactSelect from 'react-select';
import { Field, Formik, ErrorMessage } from 'formik';
import * as Yup from 'yup'
import { Option, LimitedChipsContainer, CustomOption } from 'components/Options';
import Calendar from 'assets/icon/calendar-icon.svg';
import useAxios from 'hooks/useAxios';
import moment from 'moment';
import { toast } from 'react-toastify';
import FormikSelectField from 'components/common/Fields/FormikSelectField';
import Loader from 'components/Loader';
import DatePicker from "react-datepicker";
import ReactInputMask from 'react-input-mask';
import "react-datepicker/dist/react-datepicker.css";
import ExcelFile from 'assets/images/ReportsType_ExcelFile.xlsx';
import ExcelDownload from 'assets/images/ReportsDownload.svg';
import info from 'assets/icon/InfoIcon.svg';
import HoverInfo from 'assets/icon/hover-InfoIcon.svg';
import HoverImage from 'react-hover-image/build';
//let ManufacturerData = [];
let pharmacyData = [];

const AddConfigurations = (
  { manvalPharacy,
    onSearch,
    Loading,
    onSave,
    application
  }
) => {

  const API = useAxios()
  const { token_type, access_token, profile } =
    JSON.parse(sessionStorage.getItem('pharmaforce')) || {};
  const { roles } = profile || {};

  const ClaimTypes = [
    { claimTypeid: 'A', claimTypeName: 'All' },
    { claimTypeid: 'C', claimTypeName: 'Captured' },
    { claimTypeid: 'NC', claimTypeName: 'Non-Captured'}
  ]

  const initialOptions = [
    { value: 'selectAll', label: 'Select All' },
  ];

  const [currentStep, setCurrentStep] = useState(1);
  const [startDate, setStartdate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [state, setState] = useState(true);
  const [selectedManufactureOption, setmanufactureOptionSelected] = useState({ optionMfSelected: [] });
  const [selectedpharmacyOption, setPharmacyOption] = useState({ optionPhSelected: [] });
  const [selectedAccumulatorOption, setAccumulatorOption] = useState({ optionAccSelected: [] })
  const [coveredEntity, setCoveredEntity] = useState([])
  const [ceid, setceid] = useState()
  const [appid, setAppid] = useState('')
  // const [application, setApplication] = useState([])
  const [reportType, setReportType] = useState([])
  const [reportid, setReportid] = useState('')
  const [reportName, setReportName] = useState('')
  const [claimid, setClaimid] = useState('')
  const [clientId, setClientId] = useState([])
  const [comments, setComments] = useState('')
  const [isChecked, setIsChecked] = useState(false);
  const [frequency, setFrequency] = useState('')
  const [ManufactureIds, setManufactureIds] = useState([])
  const [accumulatorIds, setAccumulatorIds] = useState([])
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  /** null = no error; 'beforeStart' | 'past' = which validation failed */
  const [endDateErrorType, setEndDateErrorType] = useState(null)

  const getEndDateErrorType = (end, start) => {
    if (!end) return null
    const endM = moment(end).startOf('day')
    const today = moment().startOf('day')
    if (start && endM.isBefore(moment(start).startOf('day'), 'day')) {
      return 'beforeStart'
    }
    if (endM.isBefore(today, 'day')) {
      return 'past'
    }
    return null
  }

  /** Earliest selectable end: today or later, and not before start when start is set (end may equal start). */
  const getMinimumEndDate = () => {
    const today = moment().startOf('day')
    if (!startDate) {
      return today.toDate()
    }
    return moment.max(today, moment(startDate).startOf('day')).toDate()
  }

  const [ManufacturerData, setManufactureData] = useState(initialOptions)
  const [accumulatorData, setAccumulatorData] = useState(initialOptions)
  const [isSelectAllChecked, setIsSelectAllChecked] = useState(false);
  const [isSelectPHChecked, setIsSelectPHChecked] = useState(false);
  const [isSelectAccChecked, setIsSelectAccChecked] = useState(false);
  const [pharmacyData1, setPharmacyData1] = useState()
  const [focusedInput, setFocusedInput] = useState('');
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [receiverID, setReceiverID] = useState(null);
  const [tradingID, setTradingID] = useState(null)
  const [OPAID, setOPAID] = useState(null);
  const [CEID, setCEID] = useState(null)
  const [submitter, setSubmitter] = useState(null);
  const [npi, setNpi] = useState(null);
  const [providerNpi, setProviderNpi] = useState(null)

  const handleToggle = () => {
    setIsChecked(!isChecked);
  };
  const Autoselect = isChecked ? 'Y' : 'N'


  let hasDatePopupOpen = false;

  const prevStep = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  const handelCancel = () => {
    setShowDetails(true)
  }

  const handleMouseLeave = () => {
    hasDatePopupOpen = false;
  };

  const handleStartDate = (startDate) => {
    if (startDate !== null) {
      const date = moment(startDate, 'MM/DD/YYYY', true);
      if (date.isValid()) {
        setStartdate(date.toDate());
        setEndDateErrorType(getEndDateErrorType(endDate, date.toDate()))
      }
    } else {
      setStartdate(null);
      setEndDateErrorType(getEndDateErrorType(endDate, null))
    }
  };

  const handleStartDateRaw = (e) => {
    var val = e.target.value;
    if (val == '__/__/____' && startDate !== null) {
      setStartdate(null);
    }
    if (val !== undefined && val.length == 10 && val.indexOf("_") == -1) {
      handleStartDate(e.target.value);
    }
  }

  const handleDateClick = (id) => {
    if (hasDatePopupOpen) {
      hasDatePopupOpen = false;
      return;
    }
    const calendarButton = document.getElementById(id);
    if (calendarButton) {
      calendarButton.click();
      hasDatePopupOpen = true;
    }
  };

  const handleEndDate = (endDate) => {
    if (endDate !== null) {
      const date = moment(endDate, 'MM/DD/YYYY', true);
      if (date.isValid()) {
        const nextEndDate = date.toDate();
        setEndDate(nextEndDate);
        setEndDateErrorType(getEndDateErrorType(nextEndDate, startDate))
      }
    } else {
      setEndDate(null);
      setEndDateErrorType(null)
    }
  };

  const handleEndDateRaw = (e) => {
    var val = e.target.value;
    if (val == '__/__/____' && endDate !== null) {
      setEndDate(null);
      setEndDateErrorType(null)
    }
    if (val !== undefined && val.length == 10 && val.indexOf("_") == -1) {
      handleEndDate(e.target.value);
    }
  }

  const onFrequencyChange = (value) => {
    if (value) {
      setFrequency(value)
    }
  }

  const getClaimTypes = (reportid) => {
    if (reportid === "NmIxTnI1b0VMd3o3azM2OWUzSEtiQT09" || reportid === "OEYxTS9uMlFEWDVmOGZHOUdSaVo3Zz09") {
      return ClaimTypes.filter(type => type.claimTypeid === 'C');
    }
    if (reportid === "TTJxYWR5MVAxYVlJMEFweldSWTJtUT09" || reportid === "TjFhcjBqc3FkaHNkTTg4K2ZyZFFidz09") {
      const withRepl = { claimTypeid: 'RP', claimTypeName: 'Replenished' };
      const hasR = ClaimTypes.some(t => t.claimTypeid === 'RP');
      return hasR ? ClaimTypes : [...ClaimTypes.filter(type => type.claimTypeid === 'C'), withRepl];
    }
    return ClaimTypes;
  };

  useEffect(() => {
    if (reportid === "NmIxTnI1b0VMd3o3azM2OWUzSEtiQT09" || reportid == "OEYxTS9uMlFEWDVmOGZHOUdSaVo3Zz09") {
      setClaimid('C')
    }
    else if (reportid === "Z3NpVnN5dTZwZ0dIK0s5dnRVL2V3QT09" || reportid === "MUZwVlp1QXNuTEtvREExMWhOVGI3UT09" || reportid ==="eTJiejRmeHFVMndlOUhpVVNBc2tWQT09") {
      setClaimid("340B")
    } else {
      setClaimid('');
    }
  }, [reportid]);

  const numSteps = 3;

  const nextStep = () => {
    if (currentStep === 1) {
      if (reportName == '' || reportid == '' || reportid == 'undefined' || appid == '' || appid == undefined || ceid == '' || ceid == undefined) {
        setError(true)
      }
      else {
        setError(false)
        setCurrentStep((prevStep) => (prevStep < numSteps && prevStep + 1));
      }
    };
    if (currentStep === 2) {
      const endDateInvalid = getEndDateErrorType(endDate, startDate) !== null

      if (frequency == '' || frequency == undefined || startDate == '' || startDate == undefined ||
        ((reportid != "NmIxTnI1b0VMd3o3azM2OWUzSEtiQT09" && reportid != "OEYxTS9uMlFEWDVmOGZHOUdSaVo3Zz09")
          && (ManufactureIds == '' || ManufactureIds == undefined
            || (!["MUZwVlp1QXNuTEtvREExMWhOVGI3UT09", "Z3NpVnN5dTZwZ0dIK0s5dnRVL2V3QT09","eTJiejRmeHFVMndlOUhpVVNBc2tWQT09"].includes(reportid) && (clientId == '' || clientId == undefined || clientId == []))))
        || (["MUZwVlp1QXNuTEtvREExMWhOVGI3UT09", "Z3NpVnN5dTZwZ0dIK0s5dnRVL2V3QT09", "eTJiejRmeHFVMndlOUhpVVNBc2tWQT09"].includes(reportid) && accumulatorIds == '' || accumulatorIds == undefined || accumulatorIds == [])
        || claimid == '' || claimid == 'undefined' || (reportid == "NmIxTnI1b0VMd3o3azM2OWUzSEtiQT09" && (!receiverID || !CEID))
        || ((reportid == "OEYxTS9uMlFEWDVmOGZHOUdSaVo3Zz09") && (tradingID == null || tradingID == '')) ||
        ((["Z3NpVnN5dTZwZ0dIK0s5dnRVL2V3QT09", "eTJiejRmeHFVMndlOUhpVVNBc2tWQT09"].includes(reportid)) && (npi == null || npi == '')) || endDateInvalid) {
        setError(true)
        setEndDateErrorType(endDateInvalid ? getEndDateErrorType(endDate, startDate) : null)
      }
      else {
        setError(false)
        setCurrentStep((prevStep) => (prevStep < numSteps && prevStep + 1));
      }
    }
  }

  const handleDiscard = () => {
    if (currentStep === 1) {
      manvalPharacy();
    }
    else {
      setCurrentStep(currentStep - 1);
    }
  };

  const handleFocus = (inputName) => {
    setFocusedInput(inputName);
  };

  const handleBlur = () => {
    setFocusedInput('');
  };

  const handleComments = (e) => {
    setComments(e.target.value)
  }

  const handelNetClaim = () => {
    setState(!state)
  }
  const netClaimValue = state ? 'Y' : 'N'

  const toggle = () => {
    setTooltipOpen(!tooltipOpen)
  }

  const fetchManufacturer = async (reportId) => {
  setManufactureData([]);
  setLoading(true);

  let apiUrl = `api/ReportConfig/manufacturers?encryptedAppTypeId=${appid}&encryptedReportTypeId=${reportId}`;
  const isRebateReport =
    reportId === "TTJxYWR5MVAxYVlJMEFweldSWTJtUT09" ||
    reportId === "TjFhcjBqc3FkaHNkTTg4K2ZyZFFidz09" ||
    reportId === "eTJiejRmeHFVMndlOUhpVVNBc2tWQT09";

  if (reportId === "TTJxYWR5MVAxYVlJMEFweldSWTJtUT09") {
    apiUrl = `api/ReportConfig/rebateManufacturers`;
  } else if (reportId === "TjFhcjBqc3FkaHNkTTg4K2ZyZFFidz09"|| reportId === "eTJiejRmeHFVMndlOUhpVVNBc2tWQT09") {
    apiUrl = `api/ReportConfig/cp2RebateManufacturers`;
  }

  try {
    const { data } = await API.get(apiUrl, { hasDefaultURL: true });

    if (!data?.length) {
      setManufactureData([]);
      return;
    }

    const formattedData = [
      ...initialOptions,
      ...data.map((item) =>
        isRebateReport
          ? {
              value: item.rebateManufacturerID,
              label: item.rebateManufacturerName,
            }
          : {
              value: item.manufacturerId,
              label: item.manufacturerName,
            }
      ),
    ];
    setManufactureData(formattedData);
  } catch (error) {
    setManufactureData([]);
  } finally {
    setLoading(false);
  }
};

  const onManufactureSelect = (selected) => {
    let newSelectedOptions;
    if (selected && selected.some(option => option.value === 'selectAll')) {
      if (selectedManufactureOption.optionMfSelected.length === ManufacturerData.length - 1) {
        newSelectedOptions = [];
      } else {
        newSelectedOptions = ManufacturerData.filter(option => option.value !== 'selectAll');
      }
    }
    else {
      newSelectedOptions = selected;
    }
    setmanufactureOptionSelected({ optionMfSelected: newSelectedOptions });
    const newManufactureIds = newSelectedOptions.map(option => option.value);
    setManufactureIds(newManufactureIds);
    setIsSelectAllChecked(newSelectedOptions.length === ManufacturerData.length - 1);
  };


  const fetchCoveredEntities = async (id) => {
    setLoading(true)
    let ApiURL = ''
    ApiURL = `api/ReportConfig/getCoveredEntitiesByAppType/${id}`
    try {
      const { data } = await API.get(ApiURL, {
        hasDefaultURL: true,
      }
      );
      if (data) {
        setCoveredEntity(data)
        setLoading(false)
      }
    } catch (error) {
      'failed to load data'
      setLoading(false)
    }
  };

  let CEname = ''
  let OPAcode = ''
  const coveredname = coveredEntity.find((item) => item.encryptedCEID == ceid)
  // if (appid == application[0]?.encryptedAppId) {
  //   CEname = coveredname ? coveredname.ceName : '';
  //   OPAcode = coveredname ? coveredname.opaCode : ''
  // }
  // if (appid == application[1]?.encryptedAppId) {
  CEname = coveredname ? coveredname.coveredEntityName : '';
  OPAcode = coveredname ? coveredname.opaCode : ''
  // }

  useEffect(() => {
    if (reportid) {
      setmanufactureOptionSelected({ optionMfSelected: [] })
      setPharmacyOption({ optionPhSelected: [] })
      setAccumulatorIds({ optionAccSelected: [] })
      setIsSelectAllChecked(false);
      setIsSelectPHChecked(false)
      setIsSelectAccChecked(false);
      setManufactureIds([])
      setClientId([]);
      setAccumulatorIds([]);
      if (!["NmIxTnI1b0VMd3o3azM2OWUzSEtiQT09", "OEYxTS9uMlFEWDVmOGZHOUdSaVo3Zz09"].includes(reportid)) {
        fetchManufacturer(reportid)
      }
      // setState(true)
      if (reportid == "Z3NpVnN5dTZwZ0dIK0s5dnRVL2V3QT09" || reportid == "MUZwVlp1QXNuTEtvREExMWhOVGI3UT09"|| reportid== "eTJiejRmeHFVMndlOUhpVVNBc2tWQT09") {
        setState(false)
      }
      else {
        setState(true)
      }
    }

  }, [reportid])

  const handleAppChange = (e) => {
    const { value } = e.target;
    setCoveredEntity([])
    setmanufactureOptionSelected({ optionMfSelected: [] })
    setIsSelectAllChecked(false);
    setManufactureIds([])
    setReportid("")
    setceid("")
    if (value) {
      setAppid(value)
      fetchCoveredEntities(value)
      fetchReportType(value)
    }
    else {
      setAppid('')
      setReportid('')
      setReportType([])
    }
  }

  const fetchReportType = async (appid) => {
    setLoading(true)
    try {
      const { data } = await API.get(`api/Report/types/${appid}`
        , {
          hasDefaultURL: true,
        }
      );
      setLoading(false)
      if (data) {
        setReportType(data)
      }

    } catch (error) {
      'failed to load data'
      setLoading(false)
    }
  };

  const fetchPharmacy = async (encryptedCEID) => {
    let ApiURL = ''
    if (appid == "bGE5aE1wM3p4dVBhbWg2QmZEWVcrQT09") {
      ApiURL = `api/ReportConfig/pharmacies/${encryptedCEID}`
    }
    if (appid == "Zm4yRjFmQjBHSmVEamtMWFkzakFCUT09") {
      ApiURL = `api/ReportConfig/cp2Pharmacies/${encryptedCEID}`
    }
    if (appid == "VHBZOGZzVytDQS9HbHpuV2FMSGQ0Zz09") {
      ApiURL = `api/ReportConfig/accumulators?encryptedParentCEID=${encryptedCEID}`
    }

    try {
      const { data } = await API.get(ApiURL, {
        hasDefaultURL: true,
      }
      )
      if (data) {
        if (appid == "VHBZOGZzVytDQS9HbHpuV2FMSGQ0Zz09") {
          if (!data?.length) {
            setAccumulatorData([])
            return
          }
          const formattedData = [
            ...initialOptions,
            ...data.map(item => {
              return { value: item.encryptedAccumulatorID, label: item.ceName }
            })
          ]
          setAccumulatorData(formattedData)
        }
        else {
          for (var x in data) {
            pharmacyData.push({ "value": data[x].clientID ? data[x].clientID : data[x].contractID, "label": data[x].phName ? data[x].phName : data[x].pharmacyName });
            const allOptions = [{ value: 'selectAll', label: 'Select All' }, ...pharmacyData];
            setPharmacyData1(allOptions);
          }
        }
      }
      else {
        setPharmacyData1([])
        setAccumulatorData([])
      }
    } catch (error) {
      'failed to load data'
      setPharmacyData1([])
      setAccumulatorData([])
    }
  };

  const handleCeChange = (e) => {
    pharmacyData = ([])
    setIsSelectPHChecked(false)
    setPharmacyOption({ optionPhSelected: [] })
    setClientId([])
    setIsSelectAccChecked(false)
    setAccumulatorOption({ optionAccSelected: [] })
    setAccumulatorIds([])
    const { value } = e.target;
    setPharmacyData1([])
    setceid(value);
    fetchPharmacy(value);
    if (value == '') {
      setError(true)
      setceid('')
    }
  }

  const onPharamcyChange = (selected) => {
    let newSelectedOptions;
    if (selected && selected.some(option => option.value === 'selectAll')) {
      if (selectedpharmacyOption.optionPhSelected.length === pharmacyData1.length - 1) {
        newSelectedOptions = [];
      } else {
        newSelectedOptions = pharmacyData1.filter(option => option.value !== 'selectAll');
      }
    } else {
      newSelectedOptions = selected;
    }
    setPharmacyOption({ optionPhSelected: newSelectedOptions });
    const newPhamarcyIds = newSelectedOptions.map(option => option.value);
    setClientId(newPhamarcyIds);
    setIsSelectPHChecked(newSelectedOptions.length === pharmacyData1.length - 1);
  };


  const onAccumulatorSelect = (selected) => {
    let newSelectedOptions;
    if (selected && selected.some(option => option.value === 'selectAll')) {
      if (selectedAccumulatorOption.optionAccSelected.length === accumulatorData.length - 1) {
        newSelectedOptions = [];
      } else {
        newSelectedOptions = accumulatorData.filter(option => option.value !== 'selectAll');
      }
    }
    else {
      newSelectedOptions = selected;
    }
    setAccumulatorOption({ optionAccSelected: newSelectedOptions });
    const newAccumulatorIds = newSelectedOptions.map(option => option.value);
    setAccumulatorIds(newAccumulatorIds);
    setIsSelectAccChecked(newSelectedOptions.length === accumulatorData.length - 1);
  };

  const handleReportChange = (e) => {
    const { value } = e.target;
    if (value) {
      setReportid(value);
      setClaimid('')
      setEndDate(null)
      setStartdate(null)
      setFrequency('')
      setOPAID(null);
      setReceiverID(null);
      setTradingID(null);
      setNpi(null);
      setProviderNpi(null);
      setCEID(null);
      setIsChecked(false);
      setSubmitter(null)
    }
    else {
      setReportid('')
      setError(true)
    }
  }

  const handleReportName = (e) => {
    setReportName(e.target.value)
  }


  const handleReceiverID = (e) => {
    setReceiverID(e.target.value)
  }

  const handleOPAID = (e) => {
    setOPAID(e.target.value)
  }

  const handleCEID = (e) => {
    setCEID(e.target.value)
  }

  const handleSubmitter = (e) => {
    setSubmitter(e.target.value)
  }

  const handleTradingID = (e) => {
    setTradingID(e.target.value)
  }

  const handleNPIChange = (e) => {
    setNpi(e.target.value)
  }

  const handleProviderNpi = (e) => {
    setProviderNpi(e.target.value)
  }


  const handleClaimTypeChange = (e) => {
    const { value } = e.target
    if (value) {
      setClaimid(value)
      if (value == "RP") {
        setState(true)
      }
      else {
        setState(true)
      }
    }
    else {
      setClaimid('')
      setError(true)
    }
  }

  const handleResponse = (response) => {
    if (response.status === 200) {
      toast.success('Configured Report Added Successfully');
    } else {
      alert('Failed to add configurations');
    }
  };

  const handleSave = async () => {
    let values = {};
    values.ApplicationId = appid,
      values.coveredEntityID = ceid
    const year = startDate.getFullYear();
    const month = (startDate.getMonth() + 1).toString().padStart(2, '0');
    const day = startDate.getDate().toString().padStart(2, '0');
    const hours = startDate.getUTCHours().toString().padStart(2, '0');
    const minutes = startDate.getUTCMinutes().toString().padStart(2, '0');
    const seconds = startDate.getUTCSeconds().toString().padStart(2, '0');
    const milliseconds = startDate.getUTCMilliseconds().toString().padStart(3, '0');
    let StartDateUTC = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}Z`
    let EndDateUTC = null
    if (endDate) {
      const Endyear = endDate.getFullYear();
      const Endmonth = (endDate.getMonth() + 1).toString().padStart(2, '0');
      const Endday = endDate.getDate().toString().padStart(2, '0');
      const Endhours = endDate.getUTCHours().toString().padStart(2, '0');
      const Endminutes = endDate.getUTCMinutes().toString().padStart(2, '0');
      const Endseconds = endDate.getUTCSeconds().toString().padStart(2, '0');
      const Endmilliseconds = endDate.getUTCMilliseconds().toString().padStart(3, '0');
      EndDateUTC = `${Endyear}-${Endmonth}-${Endday}T${Endhours}:${Endminutes}:${Endseconds}.${Endmilliseconds}Z`
    }
    var payload = {}
    payload.reportConfigID = 0,
      payload.encryptedCEID = ceid,
      payload.ceName = CEname,
      payload.opaCode = OPAcode,
      payload.reportName = reportName,
      payload.encryptedReportTypeID = reportid,
      payload.frequency = frequency,
      payload.claimType = claimid,
      payload.startDate = StartDateUTC,
      payload.endDate = EndDateUTC
    payload.netClaims = netClaimValue,
      payload.autoSend = Autoselect,
      payload.comments = comments,
      payload.mfgIDs = ManufactureIds,
      payload.clientIDs = clientId,
      payload.receiverID = receiverID,
      payload.accumulatorIDs = accumulatorIds,
      payload.tradingPartnerID = tradingID,
      payload.encryptedApplicationID = appid,
      payload.opaid = OPAID,
      payload.ce_id = CEID,
      payload.submitterNPI = submitter,
      payload.npi = npi || providerNpi || null,
      setLoading(true)
    try {
      const response = await API.post(`api/Report/add`, payload,
        {
          hasDefaultURL: true,
        })
      handleResponse(response);
      setLoading(false)
      onSave();
      
    }
    catch (error) {
      setLoading(false);
    }
    manvalPharacy();
    setLoading(true)
  }

  return (
    <Formik
      children={(props) => {
        const { setFieldValue } = props;
        return (
          <div>
            {Loading && <Loader opacity={0.01} color='black' DrawerLoading />}
            <Card className='' style={{ height: "calc(100vh - 100px)", background: "transparent", border: "none" }}>
              <CardBody>
                <div>
                  <div className='step_info'>
                    <div className="stepper">
                      <div>
                        <div className="stepper-horizontal" id="stepper1">
                          {Array.from({ length: numSteps }, (_, index) => {
                            const stepNum = index + 1;
                            return (
                              <div
                                className={`step ${stepNum === currentStep ? 'editing fffff' : ''} ${stepNum < currentStep ? 'done' : ''}`}
                                key={stepNum}
                              >
                                <div className="step-circle">
                                  <span>{stepNum}</span>
                                </div>
                                <div className="step-title">
                                  {
                                    stepNum === 1 ? 'Report Details' :
                                      stepNum === 2 ? 'Report Configuration' :
                                        stepNum === 3 ? 'Report Settings' : ''
                                  }
                                </div>
                                <div className="step-bar-left"></div>
                                <div className="step-bar-right"></div>
                              </div>
                            );
                          })}
                        </div>
                        <div>
                          {currentStep && (
                            <div className="step-content">
                              {currentStep === 1 &&
                                <div>
                                  <div className="d-flex justify-content-between section-devider-border">
                                    <h3 className='font-20'>Report Details</h3>
                                  </div>
                                  <Row className='d-flex pt-3' style={{}}>
                                    <Col md={6} lg={6} sm={6} xs={6}  >
                                      {' '}
                                      <FormGroup>
                                        <Label
                                          htmlFor="application" for='reportname'
                                          className={focusedInput === 'application' ? 'label-focus' : 'required'}
                                        >Application <span>*</span></Label>
                                        <Field
                                          name='Application'
                                          type='text'
                                          className="required"
                                          value={appid}
                                          onChange={(e) => handleAppChange(e)}
                                          component={FormikSelectField}
                                          options={application}
                                          defaultoption="--select--"
                                          keys={{
                                            id: 'encryptedAppId',
                                            label: 'applicationType',
                                          }}
                                        />
                                        {(error) && (appid == '' || appid == undefined) && <div className="text-danger f-12">
                                          Application id is required </div>}
                                      </FormGroup>
                                    </Col>
                                    <Col md={6} lg={6} sm={6} xs={6}  >
                                      {' '}
                                      <FormGroup>
                                        <Label
                                          htmlFor="coveredentity" for='reportname'
                                          className={focusedInput === 'coveredentity' ? 'label-focus' : 'required'}
                                        >Covered Entity /OPAID <span>*</span></Label>
                                        <Field
                                          className="required"
                                          name='covereEntity'
                                          disabled={appid == ""}
                                          type='text'
                                          value={ceid}
                                          onChange={(e) => handleCeChange(e)}
                                          component={FormikSelectField}
                                          options={coveredEntity}
                                          onFocus={() => handleFocus('coveredentity')}
                                          onBlur={handleBlur}
                                          defaultoption='--select--'

                                          keys={
                                            // appid ==  application?.[0]?.encryptedAppId ? 
                                            {
                                              // id: 'encryptedCEID',
                                              // label: 'ceName',
                                              // }
                                              //  : 
                                              //  {
                                              id: 'encryptedCEID',
                                              label: 'coveredEntityName',
                                            }}

                                        />
                                        {(error) && (ceid == '' || ceid == undefined) && <div className="text-danger f-12">
                                          Covered Entity name is required </div>}
                                      </FormGroup>
                                    </Col>
                                    <Col md={6} lg={6} sm={6} xs={6}  >
                                      {' '}
                                      <FormGroup>
                                        <Label
                                          htmlFor="ReportName" for='reportname'
                                          className={focusedInput === 'ReportName' ? 'label-focus' : 'required'}
                                        >Report Name <span>*</span></Label>
                                        <Input
                                          className="required iconremove"
                                          id="reportName"
                                          name="reportName"
                                          type="text"
                                          //className="required"
                                          placeholder="Enter Report name"
                                          autoComplete="off"
                                          value={reportName}
                                          onFocus={() => handleFocus('ReportName')}
                                          onBlur={handleBlur}
                                          //component={FormikInputField}
                                          onChange={handleReportName}
                                        // onChange={(e) => { handleInvoiceNumberOnChange(e, setFieldValue) }}
                                        />
                                        {(error) && (reportName == '') && <div className="text-danger f-12">
                                          Please enter the Report Name</div>}
                                      </FormGroup>
                                    </Col>
                                    <Col md={6} lg={6} sm={6} xs={6}  >
                                      {' '}
                                      <FormGroup>
                                        <Label for='reportname'></Label>
                                        <Label
                                          htmlFor="reporttype" for='reportname'
                                          className={focusedInput === 'reporttype' ? 'label-focus' : 'required'}
                                        >Report Type <span>*</span></Label>
                                        {(reportid == "OFNzN0lSaS9pK2FzKzRSdzRaM29ZUT09" || reportid == "cEJmc25WQm82QUNCLy85blNIWCtmQT09" || reportid == "ejkwVkJObUJzbEM4WDRPRGhBK3FkUT09" || reportid == "WWdDbzZzMXNHaGVMS3JtNEMva1ZBdz09") &&
                                          // <Button onClick={handleDownload} style={{ float: "right", background: "none", border: "none" }}>
                                          //   <img src={ExcelDownload} alt="download" title="Report type details" />
                                          // </Button>
                                          <a style={{ float: "right" }} href={ExcelFile} download><img src={ExcelDownload} /></a>
                                        }
                                        <Field
                                          className="required"
                                          name='ReportType'
                                          type='text'
                                          value={reportid}
                                          disabled={appid == ""}
                                          onChange={handleReportChange}
                                          component={FormikSelectField}
                                          options={reportType}
                                          onFocus={() => handleFocus('reporttype')}
                                          onBlur={handleBlur}
                                          defaultoption='--select--'
                                          keys={{
                                            id: 'encryptedReportTypeID',
                                            label: 'reportTypeName',
                                          }}
                                        />{(error) && (reportid == '' || reportid == undefined) && <div className="text-danger f-12">
                                          Report Type is required </div>}

                                      </FormGroup>
                                    </Col>

                                  </Row>
                                </div>
                              }
                              {currentStep === 2 &&
                                <div>
                                  <div className="d-flex justify-content-between section-devider-border">
                                    <h3 className='font-20'>Report Configurations</h3>
                                  </div>
                                  <Row className='pt-3'>
                                    {(!["MUZwVlp1QXNuTEtvREExMWhOVGI3UT09", "Z3NpVnN5dTZwZ0dIK0s5dnRVL2V3QT09", "eTJiejRmeHFVMndlOUhpVVNBc2tWQT09"].includes(reportid)) &&
                                      <Col md={3} lg={6} sm={6} xs={6}  >
                                        {' '}
                                        <FormGroup className='controls'>
                                          <Label for='reportname'></Label>
                                          <Label
                                            htmlFor="ClaimType" for='reportname'
                                            className={focusedInput === 'ClaimType' ? 'label-focus' : 'required'}
                                          >Claim Type <span>*</span></Label>
                                          <Field
                                            className="required"
                                            name='ClaimType'
                                            type='text'
                                            value={claimid}
                                            onChange={(e) => handleClaimTypeChange(e)}
                                            component={FormikSelectField}
                                            options={getClaimTypes(reportid)}
                                            onFocus={() => handleFocus('ClaimType')}
                                            onBlur={handleBlur}
                                            disabled={reportid == "NmIxTnI1b0VMd3o3azM2OWUzSEtiQT09" || reportid == "OEYxTS9uMlFEWDVmOGZHOUdSaVo3Zz09"}
                                            defaultoption={(reportid == "NmIxTnI1b0VMd3o3azM2OWUzSEtiQT09" || reportid == "OEYxTS9uMlFEWDVmOGZHOUdSaVo3Zz09") ? 'Captured' : '--select--'}
                                            keys={{
                                              id: 'claimTypeid',
                                              label: 'claimTypeName',
                                            }}
                                          />
                                          {(error) && (claimid == '' || claimid == undefined) && <div className="text-danger f-12">
                                            Claims Type is required </div>}
                                        </FormGroup>
                                      </Col>
                                    }
                                    {
                                      (reportid == 'OFNzN0lSaS9pK2FzKzRSdzRaM29ZUT09' || reportid == "cEJmc25WQm82QUNCLy85blNIWCtmQT09" || reportid == "ejkwVkJObUJzbEM4WDRPRGhBK3FkUT09" || reportid == "WWdDbzZzMXNHaGVMS3JtNEMva1ZBdz09") &&
                                      <Col md={6} lg={6} sm={12} xs={12} className="minw-0">
                                        <FormGroup>
                                          <Label
                                            htmlFor="OPAID" for='OPAID'
                                            className={focusedInput === 'OPAID' && 'label-focus'}
                                          >OPAID<span style={{ fontSize: "12px" }}>(optional)</span> </Label>
                                          <Input
                                            className="iconremove"
                                            id="OPAID"
                                            name="OPAID"
                                            type="text"
                                            maxLength={50}
                                            placeholder="Enter OPAID"
                                            autoComplete="off"
                                            value={OPAID}
                                            onFocus={() => handleFocus('OPAID')}
                                            onBlur={handleBlur}
                                            onChange={handleOPAID}

                                          />
                                        </FormGroup>
                                      </Col>
                                    }
                                     {(reportid == "Z3NpVnN5dTZwZ0dIK0s5dnRVL2V3QT09"|| reportid ==  "eTJiejRmeHFVMndlOUhpVVNBc2tWQT09") &&
                                      <Row>
                                        <Col md={3} lg={6} sm={6} xs={6}>
                                          <FormGroup>
                                            <Label
                                              htmlFor="NPI" for='NPI'
                                              className={focusedInput === 'NPI' ? 'label-focus' : 'required'}
                                            >NPI <span>*</span></Label>
                                            <Input
                                              className="required iconremove"
                                              id="NPI"
                                              name="NPI"
                                              type="text"
                                              //className="required"
                                              maxLength={15}
                                              placeholder="Enter NPI"
                                              autoComplete="off"
                                              value={npi}
                                              onFocus={() => handleFocus('NPI')}
                                              onBlur={handleBlur}
                                              //component={FormikInputField}
                                              onChange={handleNPIChange}
                                            // onChange={(e) => { handleInvoiceNumberOnChange(e, setFieldValue) }}
                                            />
                                            {(error) && (npi == null || npi == '') && <div className="text-danger f-12">
                                              NPI is Required</div>}
                                          </FormGroup>
                                        </Col>
                                      </Row>
                                    }
                                       {reportid == "MUZwVlp1QXNuTEtvREExMWhOVGI3UT09" &&
                                         <Col md={3} lg={6} sm={6} xs={6}>
                                          <FormGroup>
                                            <Label
                                              htmlFor="providerNpi" for='providerNpi'
                                              className={focusedInput === 'providerNpi' ? 'label-focus' : 'required'}
                                            > Service provider ID (NPI)</Label>
                                            <Input
                                              className="iconremove"
                                              id="providerNpi"
                                              name="providerNpi"
                                              type="text"
                                              maxLength={15}
                                              //className="required"
                                              placeholder="Enter NPI"
                                              autoComplete="off"
                                              value={providerNpi}
                                              onFocus={() => handleFocus('providerNpi')}
                                              onBlur={handleBlur}
                                              onChange={handleProviderNpi}
                                            />
                                          </FormGroup>
                                          </Col>
                                        }
                                    {["Rm9kNDFrcFlpMnJ6d2duMndLaUtJUT09", "azlRUVFPRlo3MzVRbitDY0NoZHRQQT09", "MUZwVlp1QXNuTEtvREExMWhOVGI3UT09"].includes(reportid) &&
                                      <Col md={6} lg={6} sm={12} xs={12} className="minw-0">
                                        <FormGroup>
                                          <Label
                                            htmlFor="submitter" for='submitter'
                                            className={focusedInput === 'submitter' && 'label-focus'}
                                          >Submitter (NPI) </Label>
                                          <Input
                                            className="iconremove"
                                            id="submitter"
                                            name="submitter"
                                            type="text"
                                            maxLength={15}
                                            placeholder="Enter Submitter (NPI)"
                                            autoComplete="off"
                                            value={submitter}
                                            onFocus={() => handleFocus('submitter')}
                                            onBlur={handleBlur}
                                            onChange={handleSubmitter}

                                          />
                                        </FormGroup>
                                      </Col>
                                    }

                                    {claimid != "RP" &&
                                      <Col md={3} lg={6} sm={6} xs={6}>

                                        <div className='d-flex justify-content-between align-items-center re_con'>
                                          <div>
                                            <Label className={focusedInput === 'NetClaims' ? 'label-focus' : ''} style={{ fontSize: "16px" }}>Net Claims
                                            </Label>
                                            {(reportid == "TTJxYWR5MVAxYVlJMEFweldSWTJtUT09" || reportid == "TjFhcjBqc3FkaHNkTTg4K2ZyZFFidz09") ? <>
                                              <span className='' style={{ display: "block" }}
                                              >When enabled, only net captured claims are generated.
                                              </span>
                                              <span className='' style={{ display: "block" }}>If a B2 arrives after a B1 has been generated in a file,</span>
                                              <span className='' style={{ display: "block" }}>the B2 will be included in the corresponding report cycle.</span>
                                            </>
                                              :
                                              <>
                                              { appid == "VHBZOGZzVytDQS9HbHpuV2FMSGQ0Zz09" ? <>
                                                <span className='' style={{ display: "block" }}
                                                >When enabled only positive quantity utilizations
                                                </span>
                                                <span className='' style={{ display: "block" }}> will generate.</span>
                                              </>
                                              :<><span className='' style={{ display: "block" }}
                                                >If Enabled, only B1 net claims
                                                </span>
                                                <span className='' style={{ display: "block" }}>will be sent</span></>
                                            }  
                                            </> 
                                             }                                         
                                          </div>
                                          <FormGroup switch style={{ paddingRight: "15px" }} className='form-check form-switch'>

                                            <Input
                                              className='form-check-input'
                                              onFocus={() => handleFocus('NetClaims')}
                                              onBlur={handleBlur}
                                              type="switch"
                                              disabled={reportid == "NmIxTnI1b0VMd3o3azM2OWUzSEtiQT09" || reportid == "OEYxTS9uMlFEWDVmOGZHOUdSaVo3Zz09" || claimid == "RP"}
                                              checked={state}
                                              onClick={handelNetClaim}
                                            />

                                          </FormGroup>
                                        </div>

                                      </Col>
                                    }
                                    {
                                      reportid == "NmIxTnI1b0VMd3o3azM2OWUzSEtiQT09" &&
                                      <Row>
                                        <Col md={6} lg={6} sm={12} xs={12}  >
                                          {' '}
                                          <FormGroup>
                                            <Label
                                              htmlFor="CEID" for='CEID'
                                              className={focusedInput === 'CEID' ? 'label-focus' : 'required'}
                                            >CE ID <span>*</span></Label>
                                            <Input
                                              className="required iconremove"
                                              id="CEID"
                                              name="CEID"
                                              type="text"
                                              //className="required"
                                              placeholder="Enter CEID"
                                              autoComplete="off"
                                              value={CEID}
                                              maxLength={50}
                                              onFocus={() => handleFocus('CEID')}
                                              onBlur={handleBlur}
                                              //component={FormikInputField}
                                              onChange={handleCEID}
                                            // onChange={(e) => { handleInvoiceNumberOnChange(e, setFieldValue) }}
                                            />
                                            {(error) && (!CEID) && <div className="text-danger f-12">
                                              CEID is Required</div>}
                                          </FormGroup>
                                        </Col>
                                      </Row>
                                    }
                                    {/* </Row> */}
                                    {/* <div className='re_con_daily'>
                                    <Row className='d-flex'> */}
                                    <Col md={6} lg={6} sm={12} xs={12} >
                                      <Label for='Frequency' style={{ display: "block" }}
                                        htmlFor="StartDate"
                                        className={focusedInput === 'Frequency' ? 'label-focus' : 'required'}
                                      >Frequency <span>*</span></Label>
                                      <div className='re_con_daily'>
                                        <ButtonGroup aria-label="Basic example" className='mb-3'
                                          onFocus={() => handleFocus('Frequency')}
                                          onBlur={handleBlur}
                                        >
                                          <Button varient="primary" className={frequency === 'DL' ? "active" : ''}
                                            onClick={() => onFrequencyChange('DL')}>Daily</Button>
                                          <Button varient="primary" className={frequency === 'WL' ? "active" : ''}

                                            onClick={() => onFrequencyChange('WL')}>Weekly</Button>
                                          {(reportid == "NmIxTnI1b0VMd3o3azM2OWUzSEtiQT09" || reportid == "OEYxTS9uMlFEWDVmOGZHOUdSaVo3Zz09") ?
                                            <>
                                              <Button varient="primary" className={frequency === 'ML' ? "active" : ''}
                                                onClick={() => onFrequencyChange('ML')}>Monthly</Button>
                                              <Button varient="primary" className={frequency === 'QL' ? "active" : ''}
                                                onClick={() => onFrequencyChange('QL')}>Quarterly</Button>
                                            </>
                                            :
                                            <Button varient="primary" className={frequency === 'BI' ? "active" : ''}
                                              onClick={() => onFrequencyChange('BI')}>Bi-Weekly</Button>
                                          }
                                        </ButtonGroup>
                                      </div>
                                      <div style={{ marginTop: '-15px', marginBottom: '15px' }}>
                                        {(error) && (frequency == '' || frequency == undefined) && <div className="text-danger f-12">
                                          Frequency is required </div>}
                                      </div>
                                    </Col>
                                    <Row>
                                      <Col md={6} lg={6} sm={12} xs={12} className="minw-0">
                                        {' '}
                                        {reportid == "NmIxTnI1b0VMd3o3azM2OWUzSEtiQT09" &&
                                          <FormGroup>
                                            <Label
                                              htmlFor="ReceipientID" for='receipientID'
                                              className={focusedInput === 'ReceipientID' ? 'label-focus' : 'required'}
                                            >Receiver ID <span>*</span></Label>
                                            <Input
                                              className="required iconremove"
                                              id="receipientID"
                                              name="receipientID"
                                              type="text"
                                              //className="required"
                                              maxLength={50}
                                              placeholder="Enter ID"
                                              autoComplete="off"
                                              value={receiverID}
                                              onFocus={() => handleFocus('ReceipientID')}
                                              onBlur={handleBlur}
                                              //component={FormikInputField}
                                              onChange={handleReceiverID}
                                            // onChange={(e) => { handleInvoiceNumberOnChange(e, setFieldValue) }}
                                            />
                                            {(error) && (receiverID == null || receiverID == '') && <div className="text-danger f-12">
                                              Receiver ID is Required</div>}
                                          </FormGroup>
                                        }
                                        {reportid == "OEYxTS9uMlFEWDVmOGZHOUdSaVo3Zz09" &&
                                          <FormGroup>
                                            <Label
                                              htmlFor="TradingPartnerID" for='tradingpartnerID'
                                              className={focusedInput === 'tradingpartnerID' ? 'label-focus' : 'required'}
                                            >Trading Partner ID <span>*</span></Label>
                                            <Input
                                              className="required iconremove"
                                              id="tradingpartnerID"
                                              name="tradingpartnerID"
                                              type="text"
                                              maxLength={50}
                                              //className="required"
                                              placeholder="Enter ID"
                                              autoComplete="off"
                                              value={tradingID}
                                              onFocus={() => handleFocus('TradingPartnerID')}
                                              onBlur={handleBlur}
                                              //component={FormikInputField}
                                              onChange={handleTradingID}
                                            // onChange={(e) => { handleInvoiceNumberOnChange(e, setFieldValue) }}
                                            />
                                            {(error) && (tradingID == null || tradingID == '') && <div className="text-danger f-12">
                                              Trading ID is Required</div>}
                                          </FormGroup>
                                        }
                                      </Col>
                                    </Row>
                                  </Row>
                                  {/* <div>
                                      <div > */}
                                  <Row className='d-flex' style={{}}>
                                    {(reportid != "NmIxTnI1b0VMd3o3azM2OWUzSEtiQT09" && reportid != "OEYxTS9uMlFEWDVmOGZHOUdSaVo3Zz09") &&
                                      <>
                                        <Col md={3} lg={6} sm={6} xs={6}>
                                          {' '}
                                          <FormGroup>
                                            <Label
                                              htmlFor="Manufacturer" for='reportname'
                                              className={focusedInput === 'Manufacturer' ? 'label-focus' : 'required'}
                                            >Manufacturer <span>*</span></Label>
                                            <ReactSelect
                                              name='Manufacturer'
                                              id='Manufacturer'
                                              options={ManufacturerData}
                                              // options={options}
                                              isMulti
                                              closeMenuOnSelect={false}
                                              hideSelectedOptions={false}
                                              optionSelected={true}
                                              onFocus={() => handleFocus('Manufacturer')}
                                              onBlur={handleBlur}
                                              type='checkbox'
                                              components={{
                                                Option: CustomOption, ValueContainer: LimitedChipsContainer
                                              }}
                                              isSearchable="true"
                                              //checked={isSelectAllChecked}
                                              onChange={onManufactureSelect}
                                              value={selectedManufactureOption.optionMfSelected}

                                              className='claim_info'
                                              maxMenuHeight={220}

                                              //  menuPlacement='auto'
                                              // memuPosition='fixed'
                                              styles={{
                                                menuPortal: (provided) => ({
                                                  ...provided,
                                                  zIndex: 9999,
                                                }),
                                                menu: (provided) => ({
                                                  ...provided,
                                                  zIndex: 999,
                                                  overflow: 'visible'
                                                }),
                                                option: (provided) => ({
                                                  ...provided,
                                                  display: 'flex',
                                                  alignItems: 'flex-start',
                                                  whiteSpace: 'normal',
                                                  wordBreak: 'break-word',
                                                  // alignItems: "start",
                                                  backgroundColor: 'transparent'

                                                })
                                              }}
                                              menuPortalTarget={document.body}
                                              isSelectAllChecked={isSelectAllChecked}
                                            />

                                            {(error) && (ManufactureIds == '' || ManufactureIds == undefined) && <div className="text-danger f-12">
                                              Manufacturer selection is required </div>}
                                          </FormGroup>
                                        </Col>

                                        <Col md={3} lg={6} sm={6} xs={6}>
                                          {' '}
                                          {(reportid == "Z3NpVnN5dTZwZ0dIK0s5dnRVL2V3QT09" || reportid === "MUZwVlp1QXNuTEtvREExMWhOVGI3UT09" || reportid === "eTJiejRmeHFVMndlOUhpVVNBc2tWQT09") ?
                                            <FormGroup>
                                              <Label for='accumulator'></Label>
                                              <Label
                                                htmlFor="accumulator" for='accumulator'
                                                className={focusedInput === 'accumulator' ? 'label-focus' : 'required'}
                                              >Accumulator <span>*</span></Label>
                                              <ReactSelect
                                                name='accumulator'
                                                id='accumulator'
                                                options={accumulatorData}
                                                isMulti
                                                closeMenuOnSelect={false}
                                                hideSelectedOptions={false}
                                                optionSelected={true}
                                                onFocus={() => handleFocus('accumulator')}
                                                onBlur={handleBlur}
                                                components={{
                                                  Option: CustomOption, ValueContainer: LimitedChipsContainer
                                                }}
                                                isSearchable="true"
                                                value={selectedAccumulatorOption.optionAccSelected}
                                                onChange={onAccumulatorSelect}
                                                className='claim_info ph'
                                                maxMenuHeight={220}
                                                styles={{
                                                  menuPortal: (provided) => ({
                                                    ...provided,
                                                    zIndex: 9999,
                                                  }),
                                                  menu: (provided) => ({
                                                    ...provided,
                                                    zIndex: 99,
                                                  }),

                                                  option: (provided) => ({
                                                    ...provided,
                                                    display: 'flex',
                                                    alignItems: 'flex',
                                                    whiteSpace: 'normal',
                                                    wordBreak: 'break-word',
                                                    alignItems: "start",
                                                    backgroundColor: 'transparent'

                                                  })
                                                }}
                                                menuPortalTarget={document.body}
                                                isSelectAllChecked={isSelectAccChecked}
                                              />
                                              {(error) && (accumulatorIds == '' || accumulatorIds == undefined) && <div className="text-danger f-12">
                                                Accumulator is required </div>}
                                            </FormGroup>
                                            :
                                            <FormGroup>
                                              <Label for='coveredentity'></Label>
                                              <Label
                                                htmlFor="Pharmacy" for='reportname'
                                                className={focusedInput === 'Pharmacy' ? 'label-focus' : 'required'}
                                              >Pharmacy <span>*</span></Label>
                                              <ReactSelect
                                                name='coveredentity'
                                                id='coveredentity'
                                                options={pharmacyData1}
                                                isMulti
                                                closeMenuOnSelect={false}
                                                hideSelectedOptions={false}
                                                optionSelected={true}
                                                onFocus={() => handleFocus('Pharmacy')}
                                                onBlur={handleBlur}
                                                components={{
                                                  Option: CustomOption, ValueContainer: LimitedChipsContainer
                                                }}
                                                isSearchable="true"
                                                value={selectedpharmacyOption.optionPhSelected}
                                                onChange={onPharamcyChange}
                                                className='claim_info ph'
                                                maxMenuHeight={220}
                                                styles={{
                                                  menuPortal: (provided) => ({
                                                    ...provided,
                                                    zIndex: 9999,
                                                  }),
                                                  menu: (provided) => ({
                                                    ...provided,
                                                    zIndex: 99,
                                                  }),

                                                  option: (provided) => ({
                                                    ...provided,
                                                    display: 'flex',
                                                    alignItems: 'flex',
                                                    whiteSpace: 'normal',
                                                    wordBreak: 'break-word',
                                                    alignItems: "start",
                                                    backgroundColor: 'transparent'

                                                  })
                                                }}
                                                menuPortalTarget={document.body}
                                                isSelectAllChecked={isSelectPHChecked}
                                              />
                                              {(error) && (clientId == '' || clientId == undefined) && <div className="text-danger f-12">
                                                Pharmacy is required </div>}
                                            </FormGroup>
                                          }
                                        </Col>
                                      </>
                                    }
                                    <Col md={3} lg={6} sm={6} xs={6} className='required-date'>
                                      <FormGroup>

                                        <Label
                                          htmlFor="StartDate" for='reportname'
                                          className={focusedInput === 'StartDate' ? 'label-focus' : 'required'}
                                        >Start Date <span>*</span></Label>
                                        <InputGroup onMouseLeave={handleMouseLeave}
                                        >
                                          <DatePicker
                                            id='StartDate'
                                            name='StartDate'
                                            className='required1'
                                            portalId='root portal'
                                            onFocus={() => handleFocus('StartDate')}
                                            onBlur={handleBlur}
                                            selected={startDate}
                                            onChange={handleStartDate}
                                            onChangeRaw={handleStartDateRaw}
                                            dateFormat="MM/dd/yyyy"
                                            placeholderText='Select a date'
                                            autoComplete='off'
                                            customInput={
                                              <ReactInputMask mask="99/99/9999"
                                                value={startDate}
                                              // maskChar=''
                                              />

                                            }
                                          />
                                          <InputGroupText
                                            onClick={() => handleDateClick('StartDate')}
                                          >
                                            <img src={Calendar} alt='' />
                                          </InputGroupText>
                                        </InputGroup>
                                        {(error) && (startDate == '' || startDate == undefined) && <div className="text-danger f-12">
                                          Start Date is required </div>}
                                      </FormGroup>
                                    </Col>

                                    <Col md={3} lg={6} sm={6} xs={6} className='required-date'>
                                      <FormGroup>

                                        <Label
                                          htmlFor="EndDate" for='reportname'
                                          className={focusedInput === 'EndDate' ? 'label-focus' : ''}
                                        >End Date</Label>
                                        <InputGroup onMouseLeave={handleMouseLeave}>
                                          <DatePicker

                                            id='EndDate'
                                            name='EndDate'
                                            onFocus={() => handleFocus('EndDate')}
                                            onBlur={handleBlur}
                                            minDate={getMinimumEndDate()}
                                            selected={endDate}
                                            portalId='root portal'
                                            onChange={handleEndDate}
                                            onChangeRaw={handleEndDateRaw}
                                            dateFormat="MM/dd/yyyy"
                                            placeholderText='Select a date'
                                            autoComplete='off'
                                            customInput={
                                              <ReactInputMask mask="99/99/9999"
                                                value={endDate}
                                              // maskChar=''
                                              />

                                            }
                                          />
                                          <InputGroupText
                                            onClick={() => handleDateClick('EndDate')}
                                          >
                                            <img src={Calendar} alt='' />
                                          </InputGroupText>
                                        </InputGroup>
                                        {endDateErrorType === 'beforeStart' ? (
                                          <div className="text-danger f-12">
                                            End date should be greater than or equal to start date
                                          </div>
                                        ) : endDateErrorType === 'past' ? (
                                          <div className="text-danger f-12">
                                            End date should be today or a future date
                                          </div>
                                        ) : null}
                                      </FormGroup>
                                    </Col>
                                  </Row>
                                  {/* </div> */}
                                  {/* </div> */}
                                  {/* </div> */}
                                </div>
                              }
                              {currentStep === 3 &&
                                <div>
                                  <div className="d-flex justify-content-between section-devider-border">
                                    <h3 className='font-20'>Report Settings</h3>
                                  </div>
                                  {(reportid != "NmIxTnI1b0VMd3o3azM2OWUzSEtiQT09" && reportid != "OEYxTS9uMlFEWDVmOGZHOUdSaVo3Zz09") &&
                                    <Col md={3} lg={6} sm={6} xs={6} className='pt-3' >
                                      <div className='d-flex justify-content-between align-items-center re_con'>
                                        <div className='d-flex align-items-center'>
                                          <Label className={focusedInput === 'AutoSend' ? 'label-focus' : 'required'} style={{ fontSize: "16px" }}>
                                            {(reportid == "TTJxYWR5MVAxYVlJMEFweldSWTJtUT09" || reportid == "TjFhcjBqc3FkaHNkTTg4K2ZyZFFidz09"|| reportid ==  "eTJiejRmeHFVMndlOUhpVVNBc2tWQT09") ? "Auto Send to Beacon"
                                              : (reportid == "Rm9kNDFrcFlpMnJ6d2duMndLaUtJUT09" || reportid == "azlRUVFPRlo3MzVRbitDY0NoZHRQQT09" || reportid == "MUZwVlp1QXNuTEtvREExMWhOVGI3UT09") ? "Auto Send to Truzo"
                                                // : reportid == "Z3NpVnN5dTZwZ0dIK0s5dnRVL2V3QT09" ? "Auto send to Medical Claims"
                                                  : "Auto Send to ESP"} </Label>
                                          <div id='info'>
                                            <HoverImage
                                              key={info}
                                              src={info}
                                              hoverSrc={HoverInfo}
                                              alt=''
                                              className="information_icon"
                                            />
                                          </div>
                                          <Tooltip
                                            isOpen={tooltipOpen}
                                            target="info"
                                            toggle={toggle}
                                            className='custom-tooltip'
                                            //delay={{show:200, hide:300}}
                                            placement='right-end'
                                            modifiers={[
                                              {
                                                name: "preventOverFlow",
                                                options: { boundary: "window" }
                                              },
                                              // {
                                              //   name:"offset",
                                              //   options:{offset:[0,10]}
                                              // }
                                            ]}
                                          >{(reportid == "TTJxYWR5MVAxYVlJMEFweldSWTJtUT09" || reportid == "TjFhcjBqc3FkaHNkTTg4K2ZyZFFidz09" || reportid ==  "eTJiejRmeHFVMndlOUhpVVNBc2tWQT09") ? "If Auto send is enabled, Reports will be sent directly to Beacon"
                                            : (reportid == "Rm9kNDFrcFlpMnJ6d2duMndLaUtJUT09" || reportid == "azlRUVFPRlo3MzVRbitDY0NoZHRQQT09" || reportid == "MUZwVlp1QXNuTEtvREExMWhOVGI3UT09") ? "If Auto send is enabled, Reports will be sent directly to Truzo"
                                              // : reportid == "Z3NpVnN5dTZwZ0dIK0s5dnRVL2V3QT09" ? "If Auto send is enabled, Reports will be sent directly to medical claims"
                                                : "If Auto send is enabled, Reports will be sent directly to ESP"}</Tooltip>
                                        </div>

                                        <FormGroup switch style={{ paddingRight: "15px" }} className='form-check form-switch'>
                                          <Input
                                            className='form-check-input'
                                            type="switch"
                                            onFocus={() => handleFocus('AutoSend')}
                                            onBlur={handleBlur}
                                            disabled={!roles?.includes("SUPADM") || ["Rm9kNDFrcFlpMnJ6d2duMndLaUtJUT09", "azlRUVFPRlo3MzVRbitDY0NoZHRQQT09", "MUZwVlp1QXNuTEtvREExMWhOVGI3UT09"].includes(reportid)}
                                            checked={isChecked}
                                            onClick={handleToggle}
                                          />
                                        </FormGroup>
                                      </div>
                                    </Col>
                                  }
                                  <Col md={6} lg={12} sm={6} xs={6} className='pt-3' >
                                    {' '}
                                    <FormGroup className='controls textarea_info'>
                                      <Label className={focusedInput === 'Comments' ? 'label-focus' : ''} for='reportname'>Comments <span className='f-12 text-muted'>(Optional)</span></Label>
                                      <Input
                                        id='reportname'
                                        name='reportname'
                                        type='textarea'
                                        placeholder="Add comment about report"
                                        onFocus={() => handleFocus('Comments')}
                                        onBlur={handleBlur}
                                        value={comments}
                                        onChange={handleComments}
                                        autoComplete='off'
                                      >
                                      </Input>
                                    </FormGroup>
                                  </Col>
                                </div>
                              }
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </CardBody>
            </Card>
            <div>
              <footer>
                <div hidden={""}>
                  <Row>
                    <Col sm={0} className="d-flex" style={{ justifyContent: "flex-end" }}>
                      <Label>{""}</Label>
                      <Button
                        color="primary"
                        className="reset"
                        onClick={handleDiscard}
                      >

                        Discard
                      </Button>
                      {currentStep > 2 ?
                        <Button
                          color="primary"
                          className="search"
                          onClick={handleSave}
                        >
                          Save
                        </Button>
                        :
                        <Button
                          color="primary"
                          className="search"
                          onClick={nextStep}
                        >
                          Next
                        </Button>
                      }
                    </Col>
                  </Row>
                </div>
              </footer>
            </div>
          </div>
        )
      }
      }
    ></Formik>
  )
}

export default AddConfigurations